import { Routes, Route, Navigate } from 'react-router-dom';
import UserSign from '../pages/UserSign';
import AppDownloadPage from '../pages/AppDownloadPage';

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<UserSign />} replace />
      <Route path="/app-download/:platform" element={<AppDownloadPage />} />
    </Routes>
  );
}
